import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Link,
  // ModalCloseButton,
  ModalBody,
  ModalFooter,
  Flex,
  Select,
  Text,
} from '@chakra-ui/react';

const isDemo = process.env.REACT_APP_IS_DEMO === 'true';

const DateAndTimeSelector = ({ eventDates,showLunchDinner, onChange }) => {
  const options = { weekday: 'short', month: 'short', day: 'numeric' };
  const optionsWithTime = { weekday: 'short', month: 'short', day: 'numeric', hour:'numeric', minute:'numeric' };

  const now = Date.now();
  return (
    <Flex justifyContent={'center'} border='0px solid yellow'>
      <Select
        onChange={onChange}
        fontWeight='600'
        maxWidth={'220px'}
        my={5}
        backgroundColor={'brand.500'}
        color='gold'
        defaultValue='default'
      >
        <option value='default' disabled={true}>
          Scegli una data
        </option>
        {eventDates.map((item, i) => {
          const pranzoCena = item.date.getHours() < 16 ? 'pranzo' : 'cena';
          const isClosed = item.status === 'closed';
          // Se pranzo consento acquisto fino alle 16:00 (+3 ore rispetto alle 13 => 3 * 3600 * 1000)
          // Se cena consento acquisto fino alle 24:00 (+4 ore rispetto alle 20 => 4 * 3600 *1000)
          // Se DEMO bypassa isExpired
          const delay = item.date.getHours() < 16 ? 3 * 3600 * 1000 : 4 * 3600 * 1000;
          const isExpired = isDemo ? false : item.date.valueOf() + delay < now ;
          return (
            <option key={i} value={item.date} disabled={isClosed || isExpired}>
              {showLunchDinner ? `${new Intl.DateTimeFormat('it', options).format(item.date)} (${pranzoCena})` : new Intl.DateTimeFormat('it', optionsWithTime).format(item.date)}
            </option>
          );
        })}
      </Select>
    </Flex>
  );
};

// MOSTRA UN MODAL DI RICHIESTA SELZIONE DATE TRA dates CON
// TITLE, BODY
// Opzionale children
// Opzionale un pulsante di cancel se passi onCancel
// Opzionale url che viene associato al pulsante OK

export const ModalInfoWithDate = ({
  title,
  body,
  isOpen,
  onClose,
  onCancel,
  url,
  eventDates,
  children,
  showLunchDinner
}) => {
  const [selectedDate, setSelectedData] = useState();

  const hasCancelButton = !!onCancel;
  const hasUrl = !!url;

  // const datesOld = getDatesFromEnv();

  return (
    <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} closeOnEsc={false} blockScrollOnMount={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        {/* <ModalCloseButton /> */}

        <ModalBody>
          {body}
          {eventDates.length ? (
            <DateAndTimeSelector
              onChange={(event) => {
                setSelectedData(event.target.value);
              }}
              eventDates={eventDates}
              showLunchDinner={showLunchDinner}
            />
          ) : null}
          {children}
          {isDemo && <Text color='gold'><br/>In questa versione Demo è possibile acquistare per date nel passato.</Text>}
        </ModalBody>
        <ModalFooter>
          {hasCancelButton && (
            <Button variant='secondary' minWidth={125} size={'lg'} mr={3} onClick={onCancel}>
              Annulla
            </Button>
          )}
          {hasUrl ? (
            <Link href={url} style={{ textDecoration: 'none' }}>
              <Button
                disabled={!selectedDate && eventDates.length}
                minWidth={125}
                size={'lg'}
                mr={3}
              >
                OK
              </Button>
            </Link>
          ) : (
            <Button
              disabled={!selectedDate && eventDates.length}
              minWidth={125}
              size={'lg'}
              mr={3}
              onClick={() => {
                onClose(selectedDate);
              }}
            >
              OK
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
